module.exports = __webpack_public_path__ + "img/sysgzt.2448e4d0.png";